export default {
    items: [
        { title: "Minecraft", images: ["mc", "mc2", "mc3", "mc4", "mc5"] },
        { title: "Traveling", images: ["travel", "travel2", "travel3", "travel4", "travel5"] }
    ]
}